import request from '@/utils/request'
// 报名接口
const auction_apply = (data) => {
  return request({
    url: '/auction/apply',
    method: 'post',
    data
  })
}

// 出价接口
const auction_bid = (data) => {
  return request({
    url: '/auction/bid',
    method: 'post',
    data
  })
}

// 我的报名
const user_applyList = (params) => {
  return request({
    url: '/auction/user/applyList',
    method: 'get',
    params
  })
}

// 我的竞拍
const user_auctionList = (params) => {
  return request({
    url: '/auction/user/auctionList',
    method: 'get',
    params
  })
}

// 是否已报名
const auction_applyed = (params) => {
  return request({
    url: '/auction/applyed',
    method: 'get',
    params
  })
}

// 项目时间轮询接口
const project_beat_time = (params) => {
  return request({
    url: '/portal/project/beat/time',
    method: 'get',
    params
  })
}

export {
  auction_apply,
  auction_bid,
  user_applyList,
  user_auctionList,
  auction_applyed,
  project_beat_time
}

